// extracted by mini-css-extract-plugin
export default {"recos":"y2-z","productCardOverride":"z2-z","rowHasBadge":"A2-z"};